const { userAgent = '' } = window?.navigator || {};

export const webViewRegex = /WebView\/(\d{4}\.\d{2}(?:\.\d)?)$/;

/**
 * Self-Invoked Boolean variable to identify native app webview users
 *
 * Usage*:
 *
 * ```
 * import isWebView from '../utils/isWebView';
 *
 * if (isWebView) {
 *    // Some functionality or hide component
 *    return <></>;
 * }
 * ```
 *
 */
const isWebView = ((str) => webViewRegex.test(str))(userAgent);

export const getAppVersion = () => (isWebView ? userAgent.match(webViewRegex)[1] : null);

export default isWebView;
